import Client from '../HttpClient';

const list = () => {
	return Client.get('/admin/api/item-group');
};

const find = (GroupName) => {
	return Client.get(`/admin/api/item-group/${GroupName}`);
};

const create = (GroupName) => {
	return Client.post('/admin/api/item-group', {
		GroupName,
	});
};

const update = (GroupName, NewGroupName) => {
	return Client.put(`/admin/api/item-group/${GroupName}`, {
		GroupName: NewGroupName,
	});
};

const remove = (GroupName) => {
	return Client.del(`/admin/api/item-group/${GroupName}`);
};

export default {
	list,
	find,
	create,
	update,
	remove,
};
